import React from 'react';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import TaskIcon from '@mui/icons-material/Task';
import { Box, Grid, Typography } from '@mui/material';
import * as Styles from '../DeliveryPortalPage.styles';
import { OrderSearchResponse } from 'api/Responses/OrderResponses';
import Theme from 'App.theme';
import { useLanguage } from 'context/AppContext';

interface InspectionMetaDataProps {
  stats: OrderSearchResponse['stats'] | null;
}

const InspectionMetaData: React.FC<InspectionMetaDataProps> = ({ stats }) => {
  const [language] = useLanguage();

  return (
    <Grid container justifyContent="space-between">
      <Styles.MetaGrid item>
        <Grid container>
          <LocalShippingIcon sx={{ color: Theme.colours.blue }} />
          <Box mr={2} />
          <Typography>{stats?.total}</Typography>
        </Grid>
        <Typography>{language.DeliveryPortal.MetaData.total}</Typography>
      </Styles.MetaGrid>
      <Box mr={2} />
      <Styles.MetaGrid item>
        <Grid container>
          <NotStartedIcon color="info" />
          <Box mr={2} />
          <Typography>{stats?.incomplete_orders}</Typography>
        </Grid>
        <Typography>{language.DeliveryPortal.MetaData.notStarted}</Typography>
      </Styles.MetaGrid>
      <Box mr={2} />
      <Styles.MetaGrid item>
        <Grid container>
          <TaskIcon color="success" />
          <Box mr={2} />
          <Typography>{stats?.complete}</Typography>
        </Grid>
        <Typography>{language.DeliveryPortal.MetaData.complete}</Typography>
      </Styles.MetaGrid>
    </Grid>
  );
};

export default InspectionMetaData;
